<template>
  <div>
    <CarouselSection />
    <PropertySection
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-delay="150"
    />
  </div>
</template>
<script>
import CarouselSection from './carouselSection.vue'
//import ServiceSection from "./serviceSection.vue";
import PropertySection from './propertySection.vue'
//import NewsSection from "./newsSection.vue";
//import TestimonialSection from "./testimonialSection.vue";
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  created() {
    AOS.init()
  },
  components: {
    CarouselSection,
    //ServiceSection,
    PropertySection,
    //NewsSection,
    //TestimonialSection
  },
  head: {
    title: {
      inner: 'Uni-Vate Properties',
    },
    meta: [
      {
        name: 'google-site-verification',
        content: 'wgxKi_f6JKZBurr242rfYmwmyjrcdkbWWBxrkcNvn90',
      },
    ],
  },
}
</script>
